import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { STRING, SUPPORT_EMAIL, EVENT_TYPE } from 'resources'
import { sendAnalyticsEvent } from 'services/analytics'

import ReklaimModal, { ModalHeader, ModalBody, ModalTitle } from 'components/ReklaimModal'

import { Button, Description, SupportLink, DescriptionContent } from './styles'

const CryptoRedemptionSuccessModal = ({
  isModalSuccessRedemptionOpen,
  handleCloseRedemptionSuccessModal,
  totalAmountInCrypto,
  walletAddress,
  crypto,
}) => {
  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.redeemCryptoRequestedScreenView, { crypto })
  }, [crypto])

  return (
    <ReklaimModal isOpen={isModalSuccessRedemptionOpen} centered>
      <ModalHeader toggle={handleCloseRedemptionSuccessModal} />
      <ModalBody>
        <ModalTitle>{STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.title}</ModalTitle>
        <Description>{STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.cryptoRedeemDescription1}</Description>
        <Description>
          {STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.cryptoRedeemDescription2}
          <SupportLink href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noopener noreferrer">
            {SUPPORT_EMAIL}
          </SupportLink>
          {STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.cryptoRedeemDescription3}
        </Description>
        <Description>{STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.toWalletAddress}</Description>
        <DescriptionContent>{walletAddress}</DescriptionContent>
        <Description>{STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.requestToSend}</Description>
        <DescriptionContent>{totalAmountInCrypto}</DescriptionContent>
        <Button onClick={handleCloseRedemptionSuccessModal}>
          {STRING.cryptoRedeemScreen.cryptoRedeemSuccessModal.redeemSuccessConfirm}
        </Button>
      </ModalBody>
    </ReklaimModal>
  )
}

CryptoRedemptionSuccessModal.propTypes = {
  isModalSuccessRedemptionOpen: PropTypes.bool.isRequired,
  handleCloseRedemptionSuccessModal: PropTypes.func.isRequired,
  totalAmountInCrypto: PropTypes.string.isRequired,
  walletAddress: PropTypes.string.isRequired,
  crypto: PropTypes.string.isRequired,
}

export default CryptoRedemptionSuccessModal
